import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Dropdown from "./Dropdown";
import { useAuth } from "../contexts/AuthContext";
import { useQuery, useMutation } from "react-query";
import { getImageUrl, frontendUrl, apiUrl } from "../helpers/common";
import Select from "react-select";
import { getOrganizationOptions } from "../../organization/components/OrganizationForm";
import { setLocalStorage } from "../helpers/browserStorage";
import usePages from "../hooks/pages/usePages";
import { usePopup } from "../contexts/PopupContext";
import { useApp } from "../contexts/AppContext";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Tooltip } from "react-tooltip";
import { LuCopyCheck } from "react-icons/lu";
import { LuCopy } from "react-icons/lu";
import { ImEmbed } from "react-icons/im";
import Axios from "axios";
import Switch from "@mui/material/Switch";

function Header() {
  const navigate = useNavigate();
  const { setAccessToken, user } = useAuth();
  const { updateAccess } = usePages();
  const { toast } = usePopup();

  const label = { inputProps: { "aria-label": "Switch demo" } };
  const [checked, setChecked] = useState(false);
  const [copied, setCopied] = useState(false);

  const { organizationId, isOwner, pages, pageId } = useApp();

  const pg = pages.find((page) => page._id === pageId);
  const menus = [
    { label: "Profile", onClick: () => navigate("/profile") },
    { label: "Users", onClick: () => navigate("/users"), key: "users" },
    {
      label: "Logout",
      onClick: () => {
        localStorage.clear();
        setAccessToken("");
        navigate("/login");
      },
    },
  ];
  const profile = user?.profilePicId?.url;
  useEffect(() => {
    const pg = pages.find((page) => page._id === pageId);
    if (pg?.access === "true") {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [pages, pageId]);

  const { mutate: updateAccessMutation } = useMutation({
    mutationFn: updateAccess,
    onSuccess: (res) => {
      const { message } = res?.data || {};
      toast(message, "success");
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while Subscribe!";
      toast(message, "error");
    },
  });

  const handleChange = (e) => {
    setChecked(e.target.checked);
    updateAccessMutation({ access: e.target.checked, pageId: pageId });
  };

  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div
      className="header-height fixed top-0 left-0 w-screen bg-white shadow-md flex justify-between items-center px-4 text-gray-700"
      style={{ zIndex: "9999" }}
    >
      <Link to="/dashboard" className="text-xl font-bold">
        Status Application
      </Link>

      <div className="flex items-center space-x-8">
        {checked && (
          <div style={{ paddingTop: "8px" }}>
            {!copied ? (
              <CopyToClipboard
                text={frontendUrl + "status-page/" + pg?.url}
                // text={
                //   '<iframe src="' +
                //   frontendUrl +
                //   "status-page/" +
                //   pg?.url +
                //   '" width="100%" height="790px" frameBorder="0" style="border: 0;"></iframe>'
                // }
                onCopy={handleCopy}
              >
                <buttons>
                  <LuCopy color="black" size="1.5rem" />
                  <Tooltip anchorSelect="buttons" clickable>
                    <span>Copy Embed URL</span>
                  </Tooltip>
                </buttons>
              </CopyToClipboard>
            ) : (
              <CopyToClipboard
                text={frontendUrl + "status-page/" + pageId}
                onCopy={handleCopy}
              >
                <buttons>
                  <LuCopyCheck color="black" size="1.5rem" />
                  <Tooltip anchorSelect="buttons" clickable>
                    <button>Copied</button>
                  </Tooltip>
                </buttons>
              </CopyToClipboard>
            )}
          </div>
        )}
        <Switch checked={checked} onChange={handleChange} />

        <Tooltip anchorSelect="#switch" clickable>
          {checked && <button>Disable the Page</button>}
          {!checked && <button>Publish the Page</button>}
        </Tooltip>

        <ChangeOrganization user={user} organizationId={organizationId} />
        <Dropdown
          label={
            <div className="flex items-center h-full">
              <button className="w-10 h-10 rounded-full bg-gray-200 overflow-hidden">
                <img
                  src={
                    getImageUrl(profile) || "./images/icons/profile-account.svg"
                  }
                  alt="profile"
                  className="object-cover w-full h-full"
                />
              </button>
            </div>
          }
          optionCls="top-12 right-0"
          menus={isOwner ? menus : menus.filter((m) => m.key !== "users")}
        />
      </div>
    </div>
  );
}

export default Header;

function ChangeOrganization({ user, organizationId }) {
  const { organizationAsOwner, organizationsAsMember } = user || {};
  const organizationOptions = getOrganizationOptions(
    organizationAsOwner,
    organizationsAsMember
  );

  return (
    <Select
      options={organizationOptions}
      onChange={(val) => {
        setLocalStorage("organizationId", val.value);
        window.location.reload();
      }}
      defaultValue={organizationOptions?.find(
        (o) => o.value === organizationId
      )}
      className="min-w-48"
    />
  );
}
